var map = {
	"./abb-color.svg": 1721,
	"./afb-color.svg": 1722,
	"./afb.svg": 1723,
	"./alb-color.svg": 1724,
	"./alb.svg": 1725,
	"./amb-color.svg": 1726,
	"./amb.svg": 1727,
	"./bbbaidja-color.svg": 1728,
	"./bbbaidjaxxx-color.svg": 1729,
	"./bdinidjaxxx-color.svg": 1730,
	"./bimb-color.svg": 1731,
	"./bimb.svg": 1732,
	"./bkr-color.svg": 1733,
	"./bkr.svg": 1734,
	"./bmriidja-color.svg": 1735,
	"./bniaidja-color.svg": 1736,
	"./bninidja-color.svg": 1737,
	"./bninidjaxxx-color.svg": 1738,
	"./bpay-color.svg": 1739,
	"./brinidja002-color.svg": 1740,
	"./bsmdidjaxxx-color.svg": 1741,
	"./bsn-color.svg": 1742,
	"./bsn.svg": 1743,
	"./btanidjaxxx-color.svg": 1744,
	"./cenaidja-color.svg": 1745,
	"./cenaidjaxxx-color.svg": 1746,
	"./cimb-color.svg": 1747,
	"./cimb.svg": 1748,
	"./citi-color.svg": 1749,
	"./citi.svg": 1750,
	"./default-bank-icon-color.png": 1751,
	"./default-bank-icon.png": 1752,
	"./gxbank-color.svg": 1753,
	"./hlb-color.svg": 1754,
	"./hlb.svg": 1755,
	"./hsbc-color.svg": 1756,
	"./hsbc.svg": 1757,
	"./ibbkidjaxxx-color.svg": 1758,
	"./kwh-color.svg": 1759,
	"./kwh.svg": 1760,
	"./mbb-color.svg": 1761,
	"./mbb.svg": 1762,
	"./nispidjaxxx-color.svg": 1763,
	"./ocbc-color.svg": 1764,
	"./ocbc.svg": 1765,
	"./pbb-color.svg": 1766,
	"./pbb.svg": 1767,
	"./pinbidja-color.svg": 1768,
	"./rhb-b.svg": 1769,
	"./rhb-color-b.svg": 1770,
	"./rhb-color.svg": 1771,
	"./rhb.svg": 1772,
	"./scb-color.svg": 1773,
	"./scb.svg": 1774,
	"./tng-color.svg": 1775,
	"./uob-color.svg": 1776,
	"./uob.svg": 1777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;